import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=952bb52a"
import script from "./TopMenu.vue?vue&type=script&lang=js"
export * from "./TopMenu.vue?vue&type=script&lang=js"
import style0 from "./TopMenu.vue?vue&type=style&index=0&id=952bb52a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports